import PropTypes from 'prop-types';
// material
// import { useTheme } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
  type: PropTypes.oneOf(['single', 'full'])
};

Logo.defaultProps = {
  type: 'full'
}

export default function Logo({ sx, type }) {
  // const theme = useTheme();
  // const PRIMARY_LIGHT = theme.palette.primary.light;
  // const PRIMARY_MAIN = theme.palette.primary.main;
  // const PRIMARY_DARK = theme.palette.primary.dark;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 100, height: 40, ...sx }}>
      <img alt="logo" src={`/static/brand/logo-${type}.png`} style={{width: 'auto', alignSelf:'center', height: 40, objectFit: 'contain'}}/>
    </Box>
  );
}
